import angular from "angular";
import template from "./admin-time-off-request-detail.html";
import AdminTimeOffRequestsViewController from "./admin-time-off-request-detail.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.instructors.timeoffrequests.view", {
    url: "/:timeOffRequestId/view",
    controller: AdminTimeOffRequestsViewController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.instructors.timeoffrequests.view", [])
  .config(config)
  .controller(
    "AdminTimeOffRequestsViewController",
    AdminTimeOffRequestsViewController,
  );
